import { enumToStaticValue } from '@/utils'
import { AccountingType } from '@/modules/money/movement/type/accountingType'

export default enumToStaticValue(AccountingType, 'accounting-type')
